__turbopack_context__.v({
  "className": "ppneuemontrealtext_889390f0-module__CEaSXa__className",
});
